// extracted by mini-css-extract-plugin
module.exports = {"ecPageRegionsServedContainer":"RegionsServed_ecPageRegionsServedContainer__FoMSs","showScale":"RegionsServed_showScale__3kBit"};